// extracted by mini-css-extract-plugin
export default {"userRequisites":"styles_userRequisites__cKda7","userRequisiteLabel":"styles_userRequisiteLabel__TKMsO"};